import { createClient } from "@supabase/supabase-js";

function getCleanSupabaseUrl(): string {
  const raw = process.env.SUPABASE_URL || process.env.VITE_SUPABASE_URL || "";
  if (!raw || typeof raw !== "string") return "";
  let clean = raw.trim().replace(/^['"]+|['"]+$/g, "");
  if (!clean) return "";
  clean = clean.replace(/\/+$|\/(auth|rest)\/v\d+.*$/i, "").trim();
  if (!clean.startsWith("http://") && !clean.startsWith("https://")) {
    clean = "https://" + clean;
  }
  try {
    return new URL(clean).origin;
  } catch {
    return "";
  }
}

const supabaseUrl = getCleanSupabaseUrl();
const supabaseAnonKey = (process.env.SUPABASE_ANON_KEY || process.env.VITE_SUPABASE_ANON_KEY || "").trim();

export const supabase = (supabaseUrl && supabaseAnonKey)
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true
      }
    })
  : null;

